import React from 'react';
import LocationTemplate from './LocationTemplate';

const RedOakPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Red Oak"
      stateName="North Carolina"
      countyName="Nash"
      zipCodes={["27868"]}
      latitude={36.0593}
      longitude={-77.9008}
      population={3430}
      historicalFact="Named after the red oak trees prevalent in the area."
      nearbyTowns={[
        "Rocky Mount, NC",
        "Nashville, NC",
        "Spring Hope, NC",
        "Bailey, NC",
        "Castalia, NC",
        "Elm City, NC",
        "Sharpsburg, NC",
        "Battleboro, NC"
      ]}
    />
  );
};

export default RedOakPage;